import { FC } from 'react'
import { Modal } from '@lounge-fe/ui-kit'
import { ReviewsModalProps } from './types'
import { t } from 'i18next'

const ReviewsModal: FC<ReviewsModalProps> = ({ children, trigger }) => {
  return (
    <Modal>
      <Modal.Trigger>{trigger}</Modal.Trigger>
      <Modal.Content size="lg">
        <Modal.Header>
          {t('general.reviews')}
          <Modal.CloseButton />
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
      </Modal.Content>
    </Modal>
  )
}

export { ReviewsModal }
